import { render, staticRenderFns } from "./AreaDoAssociadoValidaDeclaracao.vue?vue&type=template&id=2134b93a&"
import script from "./AreaDoAssociadoValidaDeclaracao.vue?vue&type=script&lang=js&"
export * from "./AreaDoAssociadoValidaDeclaracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports